import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './productRateModal.css';
import CreateEdit from '../PolicyProduct/RiskFactor/ProductRate/CreateEdit';

function productRateCreateModal({ handleClose, productId, setNewValue }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          setNewValue={setNewValue}
          closeCreateEditForm={handleClose}
          productRateEditDatas={null}
          editStatus={false}
          productId={productId}
        />
      </DialogContent>
    </Dialog>
  );
}

export default productRateCreateModal;
